// extracted by mini-css-extract-plugin
export default {"componentWrapper":"WiseLabel_componentWrapper__iPzwJ","new":"WiseLabel_new__SCg6M","promotion":"WiseLabel_promotion__ihAnx","bestseller":"WiseLabel_bestseller__2ELZh"};